// extracted by mini-css-extract-plugin
export default {"container":"VideoContainer_container__vb3iz"};